export var TEXTS = {
  TITLE: 'личный кабинет',
  SITE: 'на сайте',
  MOBILE: 'в мобильном приложении'
};
export var AUTH_LINK = '/login/';